import {
  StyledMedicalContent,
  StyledMedicalContentLabel,
} from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalHistory.styled";
import { useSelector } from "src/redux/hooks";

import MedicalSectionWrapper from "../MedicalSectionWrapper";
import LeaveOnboardModal from "./LeaveOnboardModal";
import MedicalSelect from "./MedicalSelect";

interface Props {
  refetch: () => Promise<void>;
}

export const MedicalPatientInformation = ({ refetch }: Props) => {
  const { URN, name, inputs } = useSelector(
    state => state.medicalHistory.patientInformation,
  );
  const selectedType =
    inputs.find(input => input.name === "status")?.value === "Active"
      ? "OnBoard"
      : "Leave";

  const genderInput = inputs.find(input => input.name === "gender");
  const dutyInput = inputs.find(input => input.name === "fitForDuty");

  return (
    <MedicalSectionWrapper name="Patient Information">
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "20px",
        }}>
        <div>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>URN: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{URN}</p>
          </StyledMedicalContent>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>Name: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{name}</p>
          </StyledMedicalContent>
        </div>

        <StyledMedicalContent
          style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <StyledMedicalContentLabel>Gender:</StyledMedicalContentLabel>
          {genderInput && (
            <MedicalSelect
              inputId={genderInput.id}
              initialValue={
                genderInput.value === "NTS" ? "Z" : genderInput.value
              }
              list={[
                { label: "Female", value: "F" },
                { label: "Male", value: "M" },
                { label: "Prefer Not To Say", value: "Z" },
              ]}
            />
          )}
        </StyledMedicalContent>

        <StyledMedicalContent
          style={{ flexDirection: "column", alignItems: "center" }}>
          <StyledMedicalContentLabel>Status: </StyledMedicalContentLabel>
          <p style={{ margin: 0 }}>
            {inputs.find(i => i.name === "status")?.value}
          </p>
        </StyledMedicalContent>

        <StyledMedicalContent
          style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <StyledMedicalContentLabel>Fit For Duty:</StyledMedicalContentLabel>
          {dutyInput && (
            <MedicalSelect
              inputId={dutyInput.id}
              initialValue={dutyInput.value}
              list={[
                { label: "Fit for Duty", value: "FFD" },
                { label: "Unfit for Duty", value: "UFD" },
              ]}
            />
          )}
        </StyledMedicalContent>

        <div>
          <LeaveOnboardModal refetch={refetch} defaultType={selectedType} />
        </div>
      </div>
    </MedicalSectionWrapper>
  );
};
